import React from 'react';
import { Card } from 'antd';
import { Collapse, Link, Typography } from 'ui-kit';
import { PayoutMethodTypes } from 'api/payoutMethods';

type Props = {
  payoutType: 'STRP';
  isOpen?: boolean;
};

type StripeInfoProps = {
  isOpen?: boolean;
};

const PayoutInfo = ({ payoutType, isOpen }: Props) => {
  if (payoutType === PayoutMethodTypes.STRIPE) {
    return <StripeInfo isOpen={isOpen} />;
  }
  return null;
};

const StripeInfo = ({ isOpen = false }: StripeInfoProps) => {
  return (
    <div id="see-how-payouts-work">
      <Collapse
        header={() => <Typography variant="h6">See how payouts work here</Typography>}
        initialCollpase={!isOpen}
      >
        <Card className="Payout-info">
          <Typography className="Payout-info-title" variant="body1">
            Connect with Stripe so we can send your payout each month. Here’s how payouts work:
          </Typography>
          <ul>
            <li>
              Payouts are monthly on the 7th of each month for services that occurred in the
              calendar month prior. For example, you will be paid for all services that were
              fulfilled in June on July 7th. Payouts often take 1-3 business days to land in your
              account.
            </li>
            <li>
              The minimum payout is $15. Funds will be held until this threshold us met. Contact
              support for special cases.
            </li>
            <li>
              Earnings may be subject to taxes and are calculated and remitted through Stripe, our
              payments partner.
            </li>
            <li>
              Payments and payouts may be subject to bank transfer fees dependent upon payout method
              and Host Co subscription.
            </li>
            <li>
              Users outside of the USA, click links to see{' '}
              <a
                href="https://docs.stripe.com/connect/cross-border-payouts"
                target="_blank"
                rel="noreferrer"
              >
                supported countries
              </a>{' '}
              and{' '}
              <a href="https://docs.stripe.com/currencies" target="_blank" rel="noreferrer">
                currencies
              </a>
              ,{' '}
              <a
                href="https://docs.stripe.com/currencies/conversions"
                target="_blank"
                rel="noreferrer"
              >
                currency
              </a>{' '}
              conversions, Stripe{' '}
              <a
                href="https://docs.stripe.com/payouts/multicurrency-settlement#multicurrency-settlement-fees"
                target="_blank"
                rel="noreferrer"
              >
                fees,
              </a>
              <a
                href="https://stripe.com/en-bg/legal/connect-account/recipient"
                target="_blank"
                rel="noreferrer"
              >
                recipient notice
              </a>{' '}
              and{' '}
              <a
                href="https://docs.stripe.com/connect/updating-service-agreements#tos-acceptance"
                target="_blank"
                rel="noreferrer"
              >
                service agreement
              </a>
              .
            </li>
            <li>
              <Link href="https://support.stripe.com/questions/payouts-faq">
                Learn more about Stripe payouts here.
              </Link>
              .
            </li>
          </ul>
        </Card>
      </Collapse>
    </div>
  );
};

export default PayoutInfo;
